/* MBG product page enhancements — vanilla JS, no dependencies.
   Each piece only activates if its markup is present on the page. */
(function () {
  'use strict';

  /* Colour swatches: click a swatch -> drive the real <select> the
     existing variant engine already listens to, so all price/image/
     availability logic stays exactly as-is. */
  document.addEventListener('click', function (evt) {
    var swatch = evt.target.closest('.mbg-swatch');
    if (!swatch) return;

    var select = document.getElementById(swatch.getAttribute('data-mbg-swatch-for'));
    if (!select) return;

    select.value = swatch.getAttribute('data-mbg-swatch-value');
    select.dispatchEvent(new Event('change', { bubbles: true }));

    var group = swatch.closest('.mbg-swatch-group');
    if (group) {
      group.querySelectorAll('.mbg-swatch').forEach(function (el) {
        el.classList.remove('is-selected');
        el.setAttribute('aria-pressed', 'false');
      });
    }
    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-pressed', 'true');
  });

  /* Mobile swipe between gallery images — reuses the theme's existing,
     already-wired thumbnail click handler (which does the real image
     switch) rather than reimplementing gallery logic. */
  var galleryEl = document.querySelector('.product-single__photos');
  if (galleryEl) {
    var touchStartX = null;

    galleryEl.addEventListener(
      'touchstart',
      function (evt) {
        touchStartX = evt.touches[0].clientX;
      },
      { passive: true }
    );

    galleryEl.addEventListener(
      'touchend',
      function (evt) {
        if (touchStartX === null) return;
        var deltaX = evt.changedTouches[0].clientX - touchStartX;
        touchStartX = null;

        if (Math.abs(deltaX) < 40) return;

        var thumbs = galleryEl.querySelectorAll('[class*="product-single__thumbnail--"]');
        if (!thumbs.length) return;

        var activeIndex = 0;
        thumbs.forEach(function (thumb, i) {
          if (thumb.classList.contains('active-thumb')) activeIndex = i;
        });

        var nextIndex = deltaX < 0 ? activeIndex + 1 : activeIndex - 1;
        if (nextIndex >= 0 && nextIndex < thumbs.length) {
          thumbs[nextIndex].click();
        }
      },
      { passive: true }
    );
  }

  /* Size guide / any other <dialog>-based modal on the page. Focus
     returns to whichever element opened it — covers the close button
     and the native Escape key, since both end up firing 'close'. */
  document.addEventListener('click', function (evt) {
    var opener = evt.target.closest('[data-mbg-open-dialog]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-mbg-open-dialog'));
      if (dialog && typeof dialog.showModal === 'function') {
        dialog._mbgOpener = opener;
        dialog.showModal();
      }
      return;
    }

    var closer = evt.target.closest('[data-mbg-close-dialog]');
    if (closer) {
      var openDialog = closer.closest('dialog');
      if (openDialog) openDialog.close();
    }
  });

  document.querySelectorAll('dialog').forEach(function (dialog) {
    dialog.addEventListener('close', function () {
      if (dialog._mbgOpener) dialog._mbgOpener.focus();
    });
  });

  /* Mobile sticky Add to Cart bar: reveal once the real buy box has
     scrolled out of view, mirror the live price via MutationObserver
     rather than re-implementing variant logic. */
  var stickyBar = document.querySelector('[data-mbg-sticky-bar]');
  var buyBox = document.querySelector('.product-form__item--submit');

  if (stickyBar && buyBox && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.hidden = entry.isIntersecting;
        });
      },
      { rootMargin: '0px 0px -50% 0px' }
    );
    observer.observe(buyBox);

    var priceTarget = stickyBar.querySelector('[data-mbg-sticky-price]');
    var priceSource = document.querySelector('[id^="ProductPrice-"]');
    if (priceTarget && priceSource && 'MutationObserver' in window) {
      var priceObserver = new MutationObserver(function () {
        priceTarget.textContent = priceSource.textContent.trim();
      });
      priceObserver.observe(priceSource, { childList: true, characterData: true, subtree: true });
    }
  }

  /* "You May Also Like" — fetch Shopify's own recommendation results.
     Fails silently (section just stays empty) if the request fails. */
  var relatedPlaceholder = document.querySelector('.mbg-related[data-url]');
  if (relatedPlaceholder) {
    fetch(relatedPlaceholder.getAttribute('data-url'))
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var populated = doc.querySelector('.mbg-related');
        if (populated) {
          relatedPlaceholder.outerHTML = populated.outerHTML;
        }
      })
      .catch(function () {});
  }
})();
